import Aurelia from 'aurelia';
// import { RouterConfiguration } from '@aurelia/router';

const au = new Aurelia();

// au.register(RouterConfiguration);

// const router = au.container.get(IRouter);

export default au;